import { PropsWithChildren, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import AddressIcon from '@/components/icons/address.svg?react'
import PackageIcon from '@/components/icons/package.svg?react'
import ProfileIcon from '@/components/icons/profile.svg?react'
import { ImpersonationBanner } from '@/components/ImpersonationBanner'
import { OnboardingTour } from '@/components/onboarding-tour/OnboardingTour'
import { Tabs } from '@/components/Tabs'
import { useRegisterScrollableContainer } from '@/helpers/ScrollToTop'
import { RoutePath } from '@/RoutePath'

function ClientPageInner({ children }: PropsWithChildren) {
  const { t } = useTranslation()
  const tabsItems = [
    {
      label: t('clientTabs.addresses'),
      value: RoutePath.ClientAddresses,
      icon: <AddressIcon className='size-5' />,
      dataTour: 'tour-addresses-tab',
    },
    {
      label: t('clientTabs.packages'),
      value: RoutePath.ClientPkg,
      icon: <PackageIcon className='size-5' />,
      dataTour: 'tour-packages-tab',
    },
    { label: t('clientTabs.profile'), value: RoutePath.ClientProfile, icon: <ProfileIcon className='size-5' /> },
  ]
  const location = useLocation()
  const scrollableRef = useRef<HTMLDivElement>(null)
  useRegisterScrollableContainer(scrollableRef)

  const getActiveTab = () => {
    if (location.pathname.includes(RoutePath.ClientProfile)) return RoutePath.ClientProfile
    if (location.pathname.includes(RoutePath.ClientPkg)) return RoutePath.ClientPkg
    if (location.pathname.includes(RoutePath.ClientAddresses)) return RoutePath.ClientAddresses
    return ''
  }
  const activeTab = getActiveTab()
  const navigate = useNavigate()

  const handleTabChange = (value: string) => {
    navigate(value)
  }

  if (!activeTab) {
    navigate(RoutePath.ClientPkg)
    return null
  }
  return (
    <div className='bg-background-app'>
      <ImpersonationBanner />
      <Tabs
        variant='underline'
        items={tabsItems}
        value={getActiveTab()}
        className='border-border-default border-b bg-white'
        onChange={handleTabChange}
      />
      <div ref={scrollableRef} className='h-[calc(100dvh-64px-var(--navbar-height))] overflow-y-auto pb-6'>
        {children}
      </div>
    </div>
  )
}

export default function ClientPage({ children }: PropsWithChildren) {
  return (
    <OnboardingTour>
      <ClientPageInner>{children}</ClientPageInner>
    </OnboardingTour>
  )
}
